import { put, takeLatest, call } from 'redux-saga/effects'
import { SubmissionError } from 'redux-form'

import { errorHandler } from '../../CandidateExperience/helpers/errorHelpers'
import { searchCandidateSkills } from '../../CandidateExperience/apiModules/candidateSkills'
import { searchCompanies } from '../../CandidateExperience/apiModules/companies'
import { searchCandidateRoles } from '../../CandidateExperience/apiModules/candidateRoles'
import * as analyticsView from '../../CandidateExperience/reducks/analytics'

import * as workHistoryModule from '../reducks/workHistory'
import * as workApi from '../apiModules/workHistory'

function* fetchWorkHistorySaga(action) {
  try {
    const response = yield workApi.fetchWorkHistory(action.payload.id)
    yield put(workHistoryModule.fetchWorkHistorySuccess(response))
  } catch (error) {}
}

function* createWorkHistorySaga(action) {
  try {
    const response = yield call(workApi.createWorkHistory, action.payload.profileId, action.payload.data)
    yield call(action.meta.resolve)
    yield put(workHistoryModule.createWorkHistorySuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    // TODO(Matt): createWorkHistoryError()
    // yield put(workHistoryModule.createWorkHistoryError(error))
    yield call(action.meta.reject, new SubmissionError({ _error: error }))
  }
}

function* updateWorkHistorySaga(action) {
  try {
    const response = yield call(workApi.updateWorkHistory, action.payload.id, action.payload)
    yield call(action.meta.resolve)
    yield put(workHistoryModule.updateWorkHistorySuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    // TODO(Matt): updateWorkHistoryError()
    // yield put(workHistoryModule.updateWorkHistoryError(error))
    yield call(action.meta.reject, new SubmissionError({ _error: error }))
  }
}

function* deleteWorkHistorySaga(action) {
  try {
    yield workApi.deleteWorkHistory(action.payload.id)
    yield put(workHistoryModule.deleteWorkHistorySuccess(action.payload.id))
  } catch (error) {}
}

function* searchSkillsSaga({ meta, payload }) {
  try {
    const response = yield searchCandidateSkills(meta.term, ['database', 'framework', 'language', 'methodology', 'process', 'tool'])

    if (response && !response.length) {
      yield put(
        analyticsView.trackEvent('Candidate: work skills', {
          action: 'no results',
          skill: meta.term,
          workHistory: meta.id,
        }),
      )
    }

    yield put(workHistoryModule.searchSkillsSuccess(payload.id, response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(workHistoryModule.searchSkillsError(error))
  }
}

function* searchCompaniesSaga({ meta, payload }) {
  try {
    const response = yield searchCompanies(meta.term)

    yield put(workHistoryModule.searchCompaniesSuccess(payload.id, response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(workHistoryModule.searchCompaniesError(error))
  }
}

function* searchRolesSaga({ meta, payload }) {
  try {
    const response = yield searchCandidateRoles(meta.term)

    yield put(workHistoryModule.searchRolesSuccess(payload.id, response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(workHistoryModule.searchRolesError(error))
  }
}

export default function* watchWorkHistorySaga() {
  yield takeLatest(workHistoryModule.FETCH, fetchWorkHistorySaga)
  yield takeLatest(workHistoryModule.UPDATE, updateWorkHistorySaga)
  yield takeLatest(workHistoryModule.CREATE, createWorkHistorySaga)
  yield takeLatest(workHistoryModule.DELETE, deleteWorkHistorySaga)
  yield takeLatest(workHistoryModule.SEARCH_SKILLS, searchSkillsSaga)
  yield takeLatest(workHistoryModule.SEARCH_COMPANIES, searchCompaniesSaga)
  yield takeLatest(workHistoryModule.SEARCH_ROLES, searchRolesSaga)
}
